var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-7"
  }, [_c('v-expansion-panels', {
    class: {
      'on-add': _vm.onAddingProcess
    },
    attrs: {
      "accordion": "",
      "expansion-panel-border-radius": "30"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "text-subtitle-1 font-weight-bold mango-red"
  }, [_vm._v("General Informations ")]), _c('v-expansion-panel-content', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.id,
      "label": "Tenant Id",
      "dense": "",
      "hide-details": "auto",
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.tenant.id,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "id", $$v);
      },
      expression: "tenant.id"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.name,
      "dense": "",
      "label": "Name",
      "hide-details": "auto",
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.tenant.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "name", $$v);
      },
      expression: "tenant.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.bookingAffiliateId,
      "dense": "",
      "label": "Booking Affiliate ID",
      "hide-details": "auto",
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.tenant.bookingAffiliateId,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "bookingAffiliateId", $$v);
      },
      expression: "tenant.bookingAffiliateId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.bookingSystems,
      "label": "Booking Systems",
      "multiple": "",
      "dense": "",
      "hide-details": "auto",
      "outlined": "",
      "chips": "",
      "small-chips": "",
      "deletable-chips": ""
    },
    model: {
      value: _vm.tenant.allowedBookingSystems,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "allowedBookingSystems", $$v);
      },
      expression: "tenant.allowedBookingSystems"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.paymentSystems,
      "label": "Payment Systems",
      "multiple": "",
      "dense": "",
      "hide-details": "auto",
      "outlined": "",
      "chips": "",
      "small-chips": "",
      "deletable-chips": ""
    },
    model: {
      value: _vm.tenant.allowedPaymentSystems,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "allowedPaymentSystems", $$v);
      },
      expression: "tenant.allowedPaymentSystems"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Is owned by Trainplanet'
    },
    model: {
      value: _vm.tenant.isOwnedByTrainPlanet,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "isOwnedByTrainPlanet", $$v);
      },
      expression: "tenant.isOwnedByTrainPlanet"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Can Sell & Use Gift Cards'
    },
    model: {
      value: _vm.tenant.canUseGiftCards,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "canUseGiftCards", $$v);
      },
      expression: "tenant.canUseGiftCards"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Can Sell Journeys'
    },
    model: {
      value: _vm.tenant.canSellJourneys,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "canSellJourneys", $$v);
      },
      expression: "tenant.canSellJourneys"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Can Sell Rail Pass Seat Reservations'
    },
    model: {
      value: _vm.tenant.canSellRailPassSeatReservations,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "canSellRailPassSeatReservations", $$v);
      },
      expression: "tenant.canSellRailPassSeatReservations"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Can Sell Rail Passes'
    },
    model: {
      value: _vm.tenant.canSellRailPasses,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "canSellRailPasses", $$v);
      },
      expression: "tenant.canSellRailPasses"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Can Sell Tickets By Invoice'
    },
    model: {
      value: _vm.tenant.canSellTicketsByInvoice,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "canSellTicketsByInvoice", $$v);
      },
      expression: "tenant.canSellTicketsByInvoice"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Can Sell Taxis'
    },
    model: {
      value: _vm.tenant.canSellTaxis,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "canSellTaxis", $$v);
      },
      expression: "tenant.canSellTaxis"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Requires National ID Verification'
    },
    model: {
      value: _vm.tenant.nationalIdNumberVerificationRequired,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "nationalIdNumberVerificationRequired", $$v);
      },
      expression: "tenant.nationalIdNumberVerificationRequired"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": "Display Main Tenant's Name in Terms & Conditions for EPS"
    },
    model: {
      value: _vm.tenant.useMainTenantsNameForToSInEPSPayload,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "useMainTenantsNameForToSInEPSPayload", $$v);
      },
      expression: "tenant.useMainTenantsNameForToSInEPSPayload"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Show Newsletter Checkbox In Checkout'
    },
    model: {
      value: _vm.tenant.showNewsletterCheckboxInCheckout,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "showNewsletterCheckboxInCheckout", $$v);
      },
      expression: "tenant.showNewsletterCheckboxInCheckout"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Use Custom Consent'
    },
    model: {
      value: _vm.tenant.useCustomConsent,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "useCustomConsent", $$v);
      },
      expression: "tenant.useCustomConsent"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Is Tora'
    },
    model: {
      value: _vm.tenant.isTora,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "isTora", $$v);
      },
      expression: "tenant.isTora"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "auto",
      "color": "greeny",
      "inset": "",
      "label": 'Send Payment Reminder Emails'
    },
    model: {
      value: _vm.tenant.sendPaymentReminderEmails,
      callback: function ($$v) {
        _vm.$set(_vm.tenant, "sendPaymentReminderEmails", $$v);
      },
      expression: "tenant.sendPaymentReminderEmails"
    }
  })], 1)], 1)], 1)], 1), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "text-subtitle-1 font-weight-bold mango-red"
  }, [_vm._v("Email Credentials ")]), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "value": _vm.tenant.emailCredentials.fromAddress,
      "label": "From Address",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.emailCredentials.fromAddress,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.emailCredentials, "fromAddress", $$v);
      },
      expression: "tenant.emailCredentials.fromAddress"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "value": _vm.tenant.emailCredentials.fromName,
      "label": "From Name",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.emailCredentials.fromName,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.emailCredentials, "fromName", $$v);
      },
      expression: "tenant.emailCredentials.fromName"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "value": _vm.tenant.emailCredentials.host,
      "label": "Host",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.emailCredentials.host,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.emailCredentials, "host", $$v);
      },
      expression: "tenant.emailCredentials.host"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.emailCredentials.username,
      "dense": "",
      "label": "Username",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.emailCredentials.username,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.emailCredentials, "username", $$v);
      },
      expression: "tenant.emailCredentials.username"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.emailCredentials.port,
      "dense": "",
      "label": "Port",
      "hide-details": "auto",
      "outlined": "",
      "type": "number"
    },
    model: {
      value: _vm.tenant.emailCredentials.port,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.emailCredentials, "port", _vm._n($$v));
      },
      expression: "tenant.emailCredentials.port"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.emailCredentials.password,
      "dense": "",
      "label": "Password",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.emailCredentials.password,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.emailCredentials, "password", $$v);
      },
      expression: "tenant.emailCredentials.password"
    }
  })], 1)], 1)], 1)], 1), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "text-subtitle-1 font-weight-bold mango-red"
  }, [_vm._v(" Theme Informations ")]), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.mainColor,
      "label": "Main Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.mainColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "mainColor", $$v);
      },
      expression: "tenant.theme.mainColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.secondaryColor,
      "label": "Secondary Color",
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.secondaryColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "secondaryColor", $$v);
      },
      expression: "tenant.theme.secondaryColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.headerColor,
      "label": "Header Color",
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.headerColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "headerColor", $$v);
      },
      expression: "tenant.theme.headerColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.headerTitleColor,
      "label": "Header Title Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.headerTitleColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "headerTitleColor", $$v);
      },
      expression: "tenant.theme.headerTitleColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.titleColor,
      "label": "Title Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.titleColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "titleColor", $$v);
      },
      expression: "tenant.theme.titleColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.titleBackgroundColor,
      "label": "Title Background Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.titleBackgroundColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "titleBackgroundColor", $$v);
      },
      expression: "tenant.theme.titleBackgroundColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.darkColor,
      "label": "Dark Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.darkColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "darkColor", $$v);
      },
      expression: "tenant.theme.darkColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.positiveColor,
      "label": "Positive Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.positiveColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "positiveColor", $$v);
      },
      expression: "tenant.theme.positiveColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.negativeColor,
      "label": "Negative Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.negativeColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "negativeColor", $$v);
      },
      expression: "tenant.theme.negativeColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.headerBackgroundColor,
      "label": "Header Background Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.headerBackgroundColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "headerBackgroundColor", $$v);
      },
      expression: "tenant.theme.headerBackgroundColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.toolbarBackgroundColor,
      "label": "Toolbar Background Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarBackgroundColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "toolbarBackgroundColor", $$v);
      },
      expression: "tenant.theme.toolbarBackgroundColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.sectionHeaderBackgroundColor,
      "label": "Section Header Background Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.sectionHeaderBackgroundColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "sectionHeaderBackgroundColor", $$v);
      },
      expression: "tenant.theme.sectionHeaderBackgroundColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.navBarBackgroundColor,
      "label": "Navbar Background Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.navBarBackgroundColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "navBarBackgroundColor", $$v);
      },
      expression: "tenant.theme.navBarBackgroundColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.appBackgroundColor,
      "label": "App Background Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.appBackgroundColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "appBackgroundColor", $$v);
      },
      expression: "tenant.theme.appBackgroundColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.mutedColor,
      "label": "Muted Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.mutedColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "mutedColor", $$v);
      },
      expression: "tenant.theme.mutedColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.borderColor,
      "label": "Border Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.borderColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "borderColor", $$v);
      },
      expression: "tenant.theme.borderColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.accentColor,
      "label": "Accent Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.accentColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "accentColor", $$v);
      },
      expression: "tenant.theme.accentColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.infoColor,
      "label": "Info Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.infoColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "infoColor", $$v);
      },
      expression: "tenant.theme.infoColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.warningColor,
      "label": "Warning Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.warningColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "warningColor", $$v);
      },
      expression: "tenant.theme.warningColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.travelModeBackgroundColor,
      "label": "Travel Mode Tab Background Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.travelModeBackgroundColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "travelModeBackgroundColor", $$v);
      },
      expression: "tenant.theme.travelModeBackgroundColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.travelModeBackgroundOpacity,
      "label": "Travel Mode Tab Background Opacity",
      "hide-details": "auto",
      "dense": "",
      "type": "number",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.travelModeBackgroundOpacity,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "travelModeBackgroundOpacity", _vm._n($$v));
      },
      expression: "tenant.theme.travelModeBackgroundOpacity"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.selectedTravelModeTabBackgroundColor,
      "label": "Selected Travel Mode Tab Background Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.selectedTravelModeTabBackgroundColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "selectedTravelModeTabBackgroundColor", $$v);
      },
      expression: "tenant.theme.selectedTravelModeTabBackgroundColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.actionColor,
      "label": "Action Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.actionColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "actionColor", $$v);
      },
      expression: "tenant.theme.actionColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.genericIconColor,
      "label": "Generic Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.genericIconColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "genericIconColor", $$v);
      },
      expression: "tenant.theme.genericIconColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.genericBorderRadius,
      "label": "Generic Border Radius",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.genericBorderRadius,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "genericBorderRadius", $$v);
      },
      expression: "tenant.theme.genericBorderRadius"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.mainActionButtonRadius,
      "label": "Main Action Button Radius",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.mainActionButtonRadius,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "mainActionButtonRadius", $$v);
      },
      expression: "tenant.theme.mainActionButtonRadius"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.fontFamily,
      "label": "Font Family",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.fontFamily,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "fontFamily", $$v);
      },
      expression: "tenant.theme.fontFamily"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.genericLetterSpacing,
      "label": "Generic Letter Spacing",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.genericLetterSpacing,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "genericLetterSpacing", $$v);
      },
      expression: "tenant.theme.genericLetterSpacing"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.mainColorSvgFilters,
      "label": "Main Color Svg Filters",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.mainColorSvgFilters,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "mainColorSvgFilters", $$v);
      },
      expression: "tenant.theme.mainColorSvgFilters"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.secondaryColorSvgFilters,
      "label": "Secondary Color Svg Filters",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.secondaryColorSvgFilters,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "secondaryColorSvgFilters", $$v);
      },
      expression: "tenant.theme.secondaryColorSvgFilters"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.mainPageUrl,
      "label": "Main Page URL",
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.mainPageUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "mainPageUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.mainPageUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.shopUrl,
      "label": "Shop URL",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.shopUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "shopUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.shopUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.customerPageUrl,
      "label": "Customer Page URL",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.customerPageUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "customerPageUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.customerPageUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.supportNumber,
      "label": "Support Number",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.supportNumber,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "supportNumber", $$v);
      },
      expression: "tenant.theme.supportNumber"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.supportEmail,
      "label": "Support Email",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.tenant.theme.supportEmail,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "supportEmail", $$v);
      },
      expression: "tenant.theme.supportEmail"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.termsAndConditionsPageUrl,
      "label": "ToS Page URL",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.termsAndConditionsPageUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "termsAndConditionsPageUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.termsAndConditionsPageUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.accessibilityUrl,
      "label": "Accessibility Page URL",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.accessibilityUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "accessibilityUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.accessibilityUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchUrl,
      "label": "Search URL",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "searchUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.searchUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.logoUrl,
      "label": "Logo SVG URL",
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.logoUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "logoUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.logoUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.logoPngUrl,
      "label": "Logo PNG URL",
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.logoPngUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "logoPngUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.logoPngUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.blackLogoUrl,
      "label": "Black Logo URL",
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.blackLogoUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "blackLogoUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.blackLogoUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.logoWidth,
      "label": "Logo Width",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.logoWidth,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "logoWidth", $$v);
      },
      expression: "tenant.theme.logoWidth"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.gtmId,
      "label": "GTM ID",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.gtmId,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "gtmId", $$v);
      },
      expression: "tenant.theme.gtmId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.loadingAnimationUrl,
      "label": "Loading Animation URL",
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.loadingAnimationUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "loadingAnimationUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.loadingAnimationUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.footerLogoUrl,
      "label": "Footer Logo URL",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.footerLogoUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "footerLogoUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.footerLogoUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.poweredByLogoUrl,
      "label": "Powered By Logo URL",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.tenant.theme.poweredByLogoUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "poweredByLogoUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.poweredByLogoUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.favIconUrl,
      "label": "Fav Icon URL",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.tenant.theme.favIconUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "favIconUrl", $$v);
      },
      expression: "tenant.theme.favIconUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.favIcon16Url,
      "label": "Fav Icon 16x16 URL",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.tenant.theme.favIcon16Url,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "favIcon16Url", $$v);
      },
      expression: "tenant.theme.favIcon16Url"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.favIcon32Url,
      "label": "Fav Icon 32x32 URL",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.tenant.theme.favIcon32Url,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "favIcon32Url", $$v);
      },
      expression: "tenant.theme.favIcon32Url"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.appleTouchIconUrl,
      "label": "Apple Touch Icon URL",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.tenant.theme.appleTouchIconUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "appleTouchIconUrl", $$v);
      },
      expression: "tenant.theme.appleTouchIconUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.maskIconUrl,
      "label": "Mask Icon URL",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.tenant.theme.maskIconUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "maskIconUrl", $$v);
      },
      expression: "tenant.theme.maskIconUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.webManifestUrl,
      "label": "Web Manifest URL",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.tenant.theme.webManifestUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "webManifestUrl", $$v);
      },
      expression: "tenant.theme.webManifestUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.browserConfigUrl,
      "label": "Browser Config URL",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.tenant.theme.browserConfigUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "browserConfigUrl", $$v);
      },
      expression: "tenant.theme.browserConfigUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.fontCssUrl,
      "label": "Font CSS URL",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.tenant.theme.fontCssUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "fontCssUrl", $$v);
      },
      expression: "tenant.theme.fontCssUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.giftCardBackgroundImageUrl,
      "label": "Gift Card Background Image URL",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.tenant.theme.giftCardBackgroundImageUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "giftCardBackgroundImageUrl", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "tenant.theme.giftCardBackgroundImageUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    staticClass: "align-stretch font-weight-bold",
    attrs: {
      "outlined": "",
      "items": _vm.locales,
      "chips": "",
      "item-value": "value",
      "item-text": "text",
      "menu-props": {
        maxHeight: '400'
      },
      "label": "Select languages",
      "multiple": "",
      "hide-details": "",
      "persistent-hint": false
    },
    model: {
      value: _vm.tenant.theme.languages,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "languages", $$v);
      },
      expression: "tenant.theme.languages"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    staticClass: "align-stretch font-weight-bold",
    attrs: {
      "outlined": "",
      "items": _vm.currencies,
      "chips": "",
      "item-value": "id",
      "item-text": "name",
      "menu-props": {
        maxHeight: '400'
      },
      "label": "Select currencies",
      "multiple": "",
      "hide-details": "",
      "persistent-hint": false
    },
    model: {
      value: _vm.tenant.theme.currencies,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "currencies", $$v);
      },
      expression: "tenant.theme.currencies"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Currency Picker',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.showCurrencyPicker,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "showCurrencyPicker", $$v);
      },
      expression: "tenant.theme.showCurrencyPicker"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Period Card Toggle',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.showPeriodCardToggle,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "showPeriodCardToggle", $$v);
      },
      expression: "tenant.theme.showPeriodCardToggle"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Train Vacation Card Toggle',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.showTrainVacationCardToggle,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "showTrainVacationCardToggle", $$v);
      },
      expression: "tenant.theme.showTrainVacationCardToggle"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Interrail Toggle',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.showInterrailToggle,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "showInterrailToggle", $$v);
      },
      expression: "tenant.theme.showInterrailToggle"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Promo Code Input Field',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.showPromoCodeInputField,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "showPromoCodeInputField", $$v);
      },
      expression: "tenant.theme.showPromoCodeInputField"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Plain Promo Code',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.plainCodeFields,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "plainCodeFields", $$v);
      },
      expression: "tenant.theme.plainCodeFields"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Border Bottom On Header',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.borderBottomOnHeader,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "borderBottomOnHeader", $$v);
      },
      expression: "tenant.theme.borderBottomOnHeader"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show FAQ Button',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.showFaqButton,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "showFaqButton", $$v);
      },
      expression: "tenant.theme.showFaqButton"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Journey Overview Icons',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.showJourneyOverviewIcons,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "showJourneyOverviewIcons", $$v);
      },
      expression: "tenant.theme.showJourneyOverviewIcons"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Corporate Agreement Codes Input Field',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.showCorporateAgreementsCodeInputField,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "showCorporateAgreementsCodeInputField", $$v);
      },
      expression: "tenant.theme.showCorporateAgreementsCodeInputField"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Prefer Outline',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.preferOutline,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "preferOutline", $$v);
      },
      expression: "tenant.theme.preferOutline"
    }
  })], 1), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.tenant.theme.preferOutline,
      expression: "tenant.theme.preferOutline"
    }],
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.outlinedFieldColor,
      "label": "Outlined Field Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.outlinedFieldColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "outlinedFieldColor", $$v);
      },
      expression: "tenant.theme.outlinedFieldColor"
    }
  })], 1)], 1)], 1)], 1), _c('v-expansion-panels', {
    staticClass: "my-8",
    attrs: {
      "accordion": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "text-subtitle-1 font-weight-bold mango-red"
  }, [_vm._v(" General Icons ")]), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.generalIcons.info.name,
      "label": "Info Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.generalIcons.info.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.generalIcons.info, "name", $$v);
      },
      expression: "tenant.theme.generalIcons.info.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.generalIcons.info.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.generalIcons.info, "isCustom", $$v);
      },
      expression: "tenant.theme.generalIcons.info.isCustom"
    }
  })], 1)], 1)], 1)], 1), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "text-subtitle-1 font-weight-bold mango-red"
  }, [_vm._v(" Search Engine Icons ")]), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.singleTickets.name,
      "label": "Single Tickets Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.singleTickets.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.singleTickets, "name", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.singleTickets.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.singleTickets.color,
      "label": "Single Tickets Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.singleTickets.color,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.singleTickets, "color", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.singleTickets.color"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.singleTickets.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.singleTickets, "isCustom", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.singleTickets.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.periodTickets.name,
      "label": "Period Tickets Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.periodTickets.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.periodTickets, "name", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.periodTickets.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.periodTickets.color,
      "label": "Period Tickets Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.periodTickets.color,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.periodTickets, "color", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.periodTickets.color"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.periodTickets.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.periodTickets, "isCustom", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.periodTickets.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.oneWay.name,
      "label": "One Way Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.oneWay.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.oneWay, "name", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.oneWay.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.oneWay.color,
      "label": "One Way Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.oneWay.color,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.oneWay, "color", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.oneWay.color"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.oneWay.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.oneWay, "isCustom", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.oneWay.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.withReturn.name,
      "label": "With Return Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.withReturn.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.withReturn, "name", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.withReturn.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.withReturn.color,
      "label": "With Return Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.withReturn.color,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.withReturn, "color", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.withReturn.color"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.withReturn.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.withReturn, "isCustom", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.withReturn.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.swap.name,
      "label": "Swap Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.swap.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.swap, "name", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.swap.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.swap.color,
      "label": "Swap Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.swap.color,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.swap, "color", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.swap.color"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.swap.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.swap, "isCustom", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.swap.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.from.name,
      "label": "From Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.from.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.from, "name", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.from.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.from.color,
      "label": "From Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.from.color,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.from, "color", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.from.color"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.from.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.from, "isCustom", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.from.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.to.name,
      "label": "To Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.to.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.to, "name", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.to.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.to.color,
      "label": "To Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.to.color,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.to, "color", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.to.color"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.to.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.to, "isCustom", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.to.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.datepicker.name,
      "label": "Datepicker Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.datepicker.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.datepicker, "name", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.datepicker.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.datepicker.color,
      "label": "Datepicker Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.datepicker.color,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.datepicker, "color", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.datepicker.color"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.datepicker.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.datepicker, "isCustom", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.datepicker.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.datepickerOutboundTime.name,
      "label": "Datepicker Outbound Time Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.datepickerOutboundTime.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.datepickerOutboundTime, "name", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.datepickerOutboundTime.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.datepickerOutboundTime.color,
      "label": "Datepicker Outbound Time Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.datepickerOutboundTime.color,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.datepickerOutboundTime, "color", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.datepickerOutboundTime.color"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.datepickerOutboundTime.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.datepickerOutboundTime, "isCustom", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.datepickerOutboundTime.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.datepickerInboundTime.name,
      "label": "Datepicker Inbound Time Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.datepickerInboundTime.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.datepickerInboundTime, "name", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.datepickerInboundTime.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.datepickerInboundTime.color,
      "label": "Datepicker Inbound Time Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.datepickerInboundTime.color,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.datepickerInboundTime, "color", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.datepickerInboundTime.color"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.datepickerInboundTime.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.datepickerInboundTime, "isCustom", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.datepickerInboundTime.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.passengerPicker.name,
      "label": "Passenger Picker Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.passengerPicker.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.passengerPicker, "name", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.passengerPicker.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.searchEngineIcons.passengerPicker.color,
      "label": "Passenger Picker Icon Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.passengerPicker.color,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.passengerPicker, "color", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.passengerPicker.color"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.searchEngineIcons.passengerPicker.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.searchEngineIcons.passengerPicker, "isCustom", $$v);
      },
      expression: "tenant.theme.searchEngineIcons.passengerPicker.isCustom"
    }
  })], 1)], 1)], 1)], 1), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "text-subtitle-1 font-weight-bold mango-red"
  }, [_vm._v(" Timetable Icons ")]), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.timetableIcons.duration.name,
      "label": "Duration Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.duration.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.duration, "name", $$v);
      },
      expression: "tenant.theme.timetableIcons.duration.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.duration.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.duration, "isCustom", $$v);
      },
      expression: "tenant.theme.timetableIcons.duration.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.timetableIcons.changes.name,
      "label": "Changes Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.changes.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.changes, "name", $$v);
      },
      expression: "tenant.theme.timetableIcons.changes.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.changes.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.changes, "isCustom", $$v);
      },
      expression: "tenant.theme.timetableIcons.changes.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.timetableIcons.transport.name,
      "label": "Transport Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.transport.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.transport, "name", $$v);
      },
      expression: "tenant.theme.timetableIcons.transport.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.transport.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.transport, "isCustom", $$v);
      },
      expression: "tenant.theme.timetableIcons.transport.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.timetableIcons.operators.name,
      "label": "Operators Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.operators.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.operators, "name", $$v);
      },
      expression: "tenant.theme.timetableIcons.operators.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.operators.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.operators, "isCustom", $$v);
      },
      expression: "tenant.theme.timetableIcons.operators.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.timetableIcons.seat.name,
      "label": "Seat Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.seat.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.seat, "name", $$v);
      },
      expression: "tenant.theme.timetableIcons.seat.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.seat.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.seat, "isCustom", $$v);
      },
      expression: "tenant.theme.timetableIcons.seat.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.timetableIcons.couchette.name,
      "label": "Couchette Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.couchette.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.couchette, "name", $$v);
      },
      expression: "tenant.theme.timetableIcons.couchette.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.couchette.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.couchette, "isCustom", $$v);
      },
      expression: "tenant.theme.timetableIcons.couchette.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.timetableIcons.berth.name,
      "label": "Berth Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.berth.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.berth, "name", $$v);
      },
      expression: "tenant.theme.timetableIcons.berth.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.timetableIcons.berth.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.timetableIcons.berth, "isCustom", $$v);
      },
      expression: "tenant.theme.timetableIcons.berth.isCustom"
    }
  })], 1)], 1)], 1)], 1), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "text-subtitle-1 font-weight-bold mango-red"
  }, [_vm._v(" Passenger Icons ")]), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.passengerIcons.adult.name,
      "label": "Adult Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.passengerIcons.adult.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.passengerIcons.adult, "name", $$v);
      },
      expression: "tenant.theme.passengerIcons.adult.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.passengerIcons.adult.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.passengerIcons.adult, "isCustom", $$v);
      },
      expression: "tenant.theme.passengerIcons.adult.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.passengerIcons.childYouth.name,
      "label": "Child/Youth Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.passengerIcons.childYouth.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.passengerIcons.childYouth, "name", $$v);
      },
      expression: "tenant.theme.passengerIcons.childYouth.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.passengerIcons.childYouth.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.passengerIcons.childYouth, "isCustom", $$v);
      },
      expression: "tenant.theme.passengerIcons.childYouth.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.passengerIcons.student.name,
      "label": "Student Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.passengerIcons.student.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.passengerIcons.student, "name", $$v);
      },
      expression: "tenant.theme.passengerIcons.student.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.passengerIcons.student.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.passengerIcons.student, "isCustom", $$v);
      },
      expression: "tenant.theme.passengerIcons.student.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.passengerIcons.retired.name,
      "label": "Retired Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.passengerIcons.retired.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.passengerIcons.retired, "name", $$v);
      },
      expression: "tenant.theme.passengerIcons.retired.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.passengerIcons.retired.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.passengerIcons.retired, "isCustom", $$v);
      },
      expression: "tenant.theme.passengerIcons.retired.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.passengerIcons.senior.name,
      "label": "Senior Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.passengerIcons.senior.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.passengerIcons.senior, "name", $$v);
      },
      expression: "tenant.theme.passengerIcons.senior.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.passengerIcons.senior.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.passengerIcons.senior, "isCustom", $$v);
      },
      expression: "tenant.theme.passengerIcons.senior.isCustom"
    }
  })], 1)], 1)], 1)], 1), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "text-subtitle-1 font-weight-bold mango-red"
  }, [_vm._v(" Toolbar Icons ")]), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.toolbarIcons.supportNumber.name,
      "label": "Support Number Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.supportNumber.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.supportNumber, "name", $$v);
      },
      expression: "tenant.theme.toolbarIcons.supportNumber.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.supportNumber.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.supportNumber, "isCustom", $$v);
      },
      expression: "tenant.theme.toolbarIcons.supportNumber.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.toolbarIcons.supportEmail.name,
      "label": "Support Email Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.supportEmail.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.supportEmail, "name", $$v);
      },
      expression: "tenant.theme.toolbarIcons.supportEmail.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.supportEmail.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.supportEmail, "isCustom", $$v);
      },
      expression: "tenant.theme.toolbarIcons.supportEmail.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.toolbarIcons.funka.name,
      "label": "Funka Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.funka.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.funka, "name", $$v);
      },
      expression: "tenant.theme.toolbarIcons.funka.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.funka.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.funka, "isCustom", $$v);
      },
      expression: "tenant.theme.toolbarIcons.funka.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.toolbarIcons.search.name,
      "label": "Search Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.search.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.search, "name", $$v);
      },
      expression: "tenant.theme.toolbarIcons.search.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.search.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.search, "isCustom", $$v);
      },
      expression: "tenant.theme.toolbarIcons.search.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.toolbarIcons.contact.name,
      "label": "Contact Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.contact.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.contact, "name", $$v);
      },
      expression: "tenant.theme.toolbarIcons.contact.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.contact.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.contact, "isCustom", $$v);
      },
      expression: "tenant.theme.toolbarIcons.contact.isCustom"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.toolbarIcons.user.name,
      "label": "User Icon",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.user.name,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.user, "name", $$v);
      },
      expression: "tenant.theme.toolbarIcons.user.name"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Is Custom",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarIcons.user.isCustom,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarIcons.user, "isCustom", $$v);
      },
      expression: "tenant.theme.toolbarIcons.user.isCustom"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('div', [_c('v-row', [_c('v-col', {
    staticClass: "mt-4",
    attrs: {
      "cols": "2"
    }
  }, [_c('h3', [_vm._v("Toolbar Options")])]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": "Show Toolbar",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarOptions.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarOptions, "enabled", $$v);
      },
      expression: "tenant.theme.toolbarOptions.enabled"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Contact Button',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarOptions.showContactButton,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarOptions, "showContactButton", $$v);
      },
      expression: "tenant.theme.toolbarOptions.showContactButton"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Customer Page Button',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarOptions.showCustomerPageButton,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarOptions, "showCustomerPageButton", $$v);
      },
      expression: "tenant.theme.toolbarOptions.showCustomerPageButton"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Funka Button',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarOptions.showFunkaButton,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarOptions, "showFunkaButton", $$v);
      },
      expression: "tenant.theme.toolbarOptions.showFunkaButton"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Mail Button',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarOptions.showMailButton,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarOptions, "showMailButton", $$v);
      },
      expression: "tenant.theme.toolbarOptions.showMailButton"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Phone Button',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarOptions.showPhoneButton,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarOptions, "showPhoneButton", $$v);
      },
      expression: "tenant.theme.toolbarOptions.showPhoneButton"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Search Button',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.toolbarOptions.showSearchButton,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.toolbarOptions, "showSearchButton", $$v);
      },
      expression: "tenant.theme.toolbarOptions.showSearchButton"
    }
  })], 1)], 1)], 1), _c('div', [_c('v-row', [_c('v-col', {
    staticClass: "mt-4",
    attrs: {
      "cols": "2"
    }
  }, [_c('h3', [_vm._v("Widget Settings")])]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.widgetSettings.tabBackgroundOpacity,
      "label": "Tab Background Opacity",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.widgetSettings.tabBackgroundOpacity,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.widgetSettings, "tabBackgroundOpacity", $$v);
      },
      expression: "tenant.theme.widgetSettings.tabBackgroundOpacity"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.widgetSettings.searchBarBackgroundColor,
      "label": "Search Bar Background Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.widgetSettings.searchBarBackgroundColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.widgetSettings, "searchBarBackgroundColor", $$v);
      },
      expression: "tenant.theme.widgetSettings.searchBarBackgroundColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.tenant.theme.widgetSettings.promoCodesBackgroundColor,
      "label": "Promo Codes Background Color",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.widgetSettings.promoCodesBackgroundColor,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.widgetSettings, "promoCodesBackgroundColor", $$v);
      },
      expression: "tenant.theme.widgetSettings.promoCodesBackgroundColor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.widgetLayoutModes,
      "item-value": "value",
      "item-text": "text",
      "label": "Layout Mode",
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.widgetLayoutMode,
      callback: function ($$v) {
        _vm.widgetLayoutMode = $$v;
      },
      expression: "widgetLayoutMode"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Dark Interrail Toggle',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.widgetSettings.darkInterrailToggle,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.widgetSettings, "darkInterrailToggle", $$v);
      },
      expression: "tenant.theme.widgetSettings.darkInterrailToggle"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Search Bar Background',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.widgetSettings.showSearchBarBackground,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme.widgetSettings, "showSearchBarBackground", $$v);
      },
      expression: "tenant.theme.widgetSettings.showSearchBarBackground"
    }
  })], 1)], 1)], 1), _c('div', [_c('v-row', [_c('h3', {
    staticClass: "ml-3 mt-6"
  }, [_vm._v("Support Page")]), _c('v-spacer'), _c('v-btn', {
    staticClass: "text-none mr-3 mb-4 mt-5 third white--text",
    on: {
      "click": _vm.addItemsupport
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("mdi-playlist-plus")]), _c('span', [_vm._v("Add Item")])], 1)], 1), _vm._l(_vm.tenant.theme.supportPageUrls, function (supportPageUrl, index) {
    return _c('v-row', {
      key: index,
      attrs: {
        "cols": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "lg": "3",
        "md": "12",
        "sm": "12",
        "xs": "12"
      }
    }, [_c('v-select', {
      staticClass: "align-stretch",
      attrs: {
        "items": _vm.locales,
        "label": "Support Page language",
        "hide-details": "auto",
        "item-value": "value",
        "item-text": "text",
        "outlined": ""
      },
      model: {
        value: supportPageUrl.locale,
        callback: function ($$v) {
          _vm.$set(supportPageUrl, "locale", $$v);
        },
        expression: "supportPageUrl.locale"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "lg": "9",
        "md": "12",
        "sm": "12",
        "xs": "12"
      }
    }, [_c('v-text-field', {
      staticClass: "mt-2",
      attrs: {
        "rules": [_vm.rules.required],
        "label": "Support Page URL",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('v-btn', {
            staticClass: "mt-2 mr-lg-n3 mt-lg-n2",
            attrs: {
              "color": "red",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.removeItemsupport(index);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)];
        },
        proxy: true
      }], null, true),
      model: {
        value: supportPageUrl.url,
        callback: function ($$v) {
          _vm.$set(supportPageUrl, "url", $$v);
        },
        expression: "supportPageUrl.url"
      }
    })], 1)], 1);
  })], 2), _c('div', [_c('v-row', [_c('h3', {
    staticClass: "ml-3 mt-6"
  }, [_vm._v("Traffic Page")]), _c('v-spacer'), _c('v-btn', {
    staticClass: "text-none mr-3 mb-4 mt-5 third white--text",
    on: {
      "click": _vm.addItemTrafficPage
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("mdi-playlist-plus")]), _c('span', [_vm._v("Add Item")])], 1)], 1), _vm._l(_vm.tenant.theme.trafficPageUrls, function (trafficPageUrl, index) {
    return _c('v-row', {
      key: index,
      attrs: {
        "cols": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "lg": "3",
        "md": "12",
        "sm": "12",
        "xs": "12"
      }
    }, [_c('v-select', {
      staticClass: "align-stretch",
      attrs: {
        "items": _vm.locales,
        "label": "Traffic Page language",
        "hide-details": "auto",
        "item-value": "value",
        "item-text": "text",
        "outlined": ""
      },
      model: {
        value: trafficPageUrl.locale,
        callback: function ($$v) {
          _vm.$set(trafficPageUrl, "locale", $$v);
        },
        expression: "trafficPageUrl.locale"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "lg": "9",
        "md": "12",
        "sm": "12",
        "xs": "12"
      }
    }, [_c('v-text-field', {
      staticClass: "mt-2",
      attrs: {
        "rules": [_vm.rules.required],
        "label": "Traffic Page URL",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('v-btn', {
            staticClass: "mt-2 mr-lg-n3 mt-lg-n2",
            attrs: {
              "color": "red",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.removeItemTrafficPage(index);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)];
        },
        proxy: true
      }], null, true),
      model: {
        value: trafficPageUrl.url,
        callback: function ($$v) {
          _vm.$set(trafficPageUrl, "url", $$v);
        },
        expression: "trafficPageUrl.url"
      }
    })], 1)], 1);
  })], 2), _c('div', [_c('v-row', [_c('h3', {
    staticClass: "ml-3 mt-6"
  }, [_vm._v("Group Order")]), _c('v-spacer'), _c('v-btn', {
    staticClass: "text-none mr-3 mb-4 mt-5 third white--text",
    on: {
      "click": _vm.addItem
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("mdi-playlist-plus")]), _c('span', [_vm._v("Add Item")])], 1)], 1), _vm._l(_vm.tenant.theme.groupOrderLinks, function (groupOrderLinks, index) {
    return _c('v-row', {
      key: index,
      attrs: {
        "cols": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('v-select', {
      attrs: {
        "items": _vm.locales,
        "label": "Group Order Links language",
        "hide-details": "auto",
        "item-value": "value",
        "item-text": "text",
        "outlined": ""
      },
      model: {
        value: groupOrderLinks.locale,
        callback: function ($$v) {
          _vm.$set(groupOrderLinks, "locale", $$v);
        },
        expression: "groupOrderLinks.locale"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "9"
      }
    }, [_c('v-text-field', {
      staticClass: "mt-2",
      attrs: {
        "rules": [_vm.rules.required],
        "label": "Group Order Links URL",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('v-btn', {
            staticClass: "mt-2 mr-lg-n3 mt-lg-n2",
            attrs: {
              "color": "red",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.removeItem(index);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)];
        },
        proxy: true
      }], null, true),
      model: {
        value: groupOrderLinks.url,
        callback: function ($$v) {
          _vm.$set(groupOrderLinks, "url", $$v);
        },
        expression: "groupOrderLinks.url"
      }
    })], 1)], 1);
  })], 2), _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('h3', {
    staticClass: "mt-3 mb-3"
  }, [_vm._v("Navigation Menu")])]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "mt-3 mb-3",
    attrs: {
      "color": "greeny",
      "inset": "",
      "label": 'Show Navigation Menu',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.tenant.theme.showNavigationMenu,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "showNavigationMenu", $$v);
      },
      expression: "tenant.theme.showNavigationMenu"
    }
  })], 1)], 1), _c('div', [_c('v-tabs', {
    staticClass: "mb-8",
    model: {
      value: _vm.activeNavigationMenuIndex,
      callback: function ($$v) {
        _vm.activeNavigationMenuIndex = $$v;
      },
      expression: "activeNavigationMenuIndex"
    }
  }, [_vm._l(_vm.tenant.theme.navigationMenu || [], function (navigationMenu, navigationMenuIndex) {
    return _c('v-tab', {
      key: navigationMenuIndex,
      staticClass: "ml-2"
    }, [_vm._v(" " + _vm._s(_vm.locales.length > 0 && _vm.locales.find(function (locale) {
      return locale.value === navigationMenu.locale;
    }).text) + " "), _c('v-btn', {
      attrs: {
        "color": "red",
        "icon": ""
      },
      on: {
        "click": function ($event) {
          return _vm.removeNavigationMenu(navigationMenuIndex);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-delete")])], 1)], 1);
  }), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-select', {
    staticClass: "mb-4 ml-7 pa-0",
    staticStyle: {
      "max-width": "max-content"
    },
    attrs: {
      "label": "Add New Translation",
      "items": _vm._f("notIn")(_vm.locales, _vm.locales, _vm.tenant.theme.navigationMenu || []),
      "hide-details": "auto",
      "item-value": "value",
      "item-text": "text",
      "persistent-hint": false
    },
    on: {
      "change": _vm.addNavigationMenu
    }
  })], 1), _c('v-tabs-items', [_c('v-row', {}, [_c('h3', {
    staticClass: "mt-7 ml-3"
  }, [_vm._v("Items")]), _c('v-spacer'), _c('v-btn', {
    staticClass: "text-none mt-5 mb-3 mr-3 white--text",
    attrs: {
      "color": "accent"
    },
    on: {
      "click": function ($event) {
        return _vm.addNavigationMenuItem(_vm.activeNavigationMenuIndex);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("mdi-playlist-plus")]), _c('span', {
    staticClass: "mr-7 ml-9"
  }, [_vm._v("Add Item")])], 1)], 1), _vm._l(_vm.tenant.theme.navigationMenu[_vm.activeNavigationMenuIndex] && _vm.tenant.theme.navigationMenu[_vm.activeNavigationMenuIndex].items || [], function (item, navigationMenuItemIndex) {
    return _c('div', {
      key: navigationMenuItemIndex,
      staticClass: "mb-3"
    }, [_c('v-row', [_c('v-col', {
      staticClass: "",
      attrs: {
        "cols": "6"
      }
    }, [_c('v-text-field', {
      staticClass: "mt-5",
      attrs: {
        "rules": [_vm.rules.required],
        "label": "Item Title",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      model: {
        value: item.title,
        callback: function ($$v) {
          _vm.$set(item, "title", $$v);
        },
        expression: "item.title"
      }
    })], 1), _c('v-col', {
      staticClass: "mt-5",
      attrs: {
        "cols": "6"
      }
    }, [_c('v-text-field', {
      staticClass: "",
      attrs: {
        "rules": [_vm.rules.required],
        "label": "Item URL",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('v-btn', {
            staticClass: "mt-2 mr-lg-n3 mt-lg-n2",
            attrs: {
              "color": "red",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.removeNavigationMenuItem(_vm.activeNavigationMenuIndex, navigationMenuItemIndex);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)];
        },
        proxy: true
      }], null, true),
      model: {
        value: item.url,
        callback: function ($$v) {
          _vm.$set(item, "url", $$v);
        },
        expression: "item.url"
      }
    })], 1)], 1), _c('v-row', {
      staticClass: "ml-8"
    }, [_c('h4', {
      staticClass: "ml-15 mt-1"
    }, [_vm._v("Child Items")]), _c('v-spacer'), _c('v-btn', {
      staticClass: "text-none pa-3 mr-3 mb-2 third white--text",
      on: {
        "click": function ($event) {
          return _vm.addNavigationMenuItemChildItem(_vm.activeNavigationMenuIndex, navigationMenuItemIndex);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "dark": ""
      }
    }, [_vm._v("mdi-playlist-plus")]), _c('span', [_vm._v("Add Child Item")])], 1)], 1), _vm._l(item.childItems || [], function (childItem, navigationMenuItemChildItemIndex) {
      return _c('v-row', {
        key: navigationMenuItemChildItemIndex,
        staticClass: ""
      }, [_c('v-col', {
        staticClass: "mb-1 pa-1",
        attrs: {
          "cols": "1"
        }
      }), _c('v-col', {
        staticClass: "mb-1 ml-lg-n8 pa-1",
        attrs: {
          "cols": "4"
        }
      }, [_c('v-text-field', {
        staticClass: "",
        attrs: {
          "rules": [_vm.rules.required],
          "label": "Child Item Title",
          "hide-details": "auto",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: childItem.title,
          callback: function ($$v) {
            _vm.$set(childItem, "title", $$v);
          },
          expression: "childItem.title"
        }
      })], 1), _c('v-col', {
        staticClass: "mb-1 pa-1",
        attrs: {
          "cols": "7"
        }
      }, [_c('v-text-field', {
        staticClass: "ml-5",
        attrs: {
          "rules": [_vm.rules.required],
          "label": "Child Item URL",
          "hide-details": "auto",
          "dense": "",
          "outlined": ""
        },
        scopedSlots: _vm._u([{
          key: "append-outer",
          fn: function () {
            return [_c('v-btn', {
              staticClass: "mt-lg-n2 mr-lg-n10",
              attrs: {
                "color": "red",
                "icon": ""
              },
              on: {
                "click": function ($event) {
                  return _vm.removeNavigationMenuItemChildItem(_vm.activeNavigationMenuIndex, navigationMenuItemIndex, navigationMenuItemChildItemIndex);
                }
              }
            }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)];
          },
          proxy: true
        }], null, true),
        model: {
          value: childItem.url,
          callback: function ($$v) {
            _vm.$set(childItem, "url", $$v);
          },
          expression: "childItem.url"
        }
      })], 1)], 1);
    })], 2);
  })], 2)], 2)], 1)], 1), _c('div', [_c('v-row', [_c('h3', {
    staticClass: "ml-3 mt-6"
  }, [_vm._v("Favorite Destinations")]), _c('v-spacer'), _c('v-btn', {
    staticClass: "text-none mr-3 mb-4 mt-5 third white--text",
    on: {
      "click": _vm.addFavoriteDestination
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("mdi-playlist-plus")]), _c('span', [_vm._v("Add Destination")])], 1)], 1), _vm._l(_vm.tenant.theme.favoriteDestinations, function (destination, index) {
    return _c('v-row', {
      key: index,
      attrs: {
        "cols": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "4"
      }
    }, [_c('v-text-field', {
      staticClass: "mt-2",
      attrs: {
        "label": "Destination ID",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      model: {
        value: destination.id,
        callback: function ($$v) {
          _vm.$set(destination, "id", $$v);
        },
        expression: "destination.id"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "4"
      }
    }, [_c('v-text-field', {
      staticClass: "mt-2",
      attrs: {
        "label": "Destination Name",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      model: {
        value: destination.name,
        callback: function ($$v) {
          _vm.$set(destination, "name", $$v);
        },
        expression: "destination.name"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "4"
      }
    }, [_c('v-text-field', {
      staticClass: "mt-2",
      attrs: {
        "label": "Country Code UIC",
        "hide-details": "auto",
        "dense": "",
        "outlined": "",
        "type": "number"
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('v-btn', {
            staticClass: "mt-2 mr-lg-n3 mt-lg-n2",
            attrs: {
              "color": "red",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.removeFavoriteDestination(index);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)];
        },
        proxy: true
      }], null, true),
      model: {
        value: destination.countryCodeUIC,
        callback: function ($$v) {
          _vm.$set(destination, "countryCodeUIC", _vm._n($$v));
        },
        expression: "destination.countryCodeUIC"
      }
    })], 1)], 1);
  })], 2), _c('div', [_c('v-row', [_c('h3', {
    staticClass: "ml-3 mt-6"
  }, [_vm._v("Default Means of Transport")])]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "items": _vm.transportModes,
      "item-value": "value",
      "item-text": "text",
      "label": "Select Transport Modes",
      "multiple": "",
      "chips": "",
      "small-chips": "",
      "deletable-chips": "",
      "hide-details": "auto",
      "menu-props": {
        maxHeight: '400'
      }
    },
    model: {
      value: _vm.tenant.theme.defaultTransportModes,
      callback: function ($$v) {
        _vm.$set(_vm.tenant.theme, "defaultTransportModes", $$v);
      },
      expression: "tenant.theme.defaultTransportModes"
    }
  })], 1)], 1)], 1), _c('div', [_c('v-row', [_c('h3', {
    staticClass: "ml-3 mt-6 mr-3"
  }, [_vm._v("Domains")]), _c('v-tooltip', {
    staticStyle: {
      "max-width": "10px"
    },
    attrs: {
      "top": "",
      "color": "black"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-help-circle-outline")])];
      }
    }])
  }, [_c('div', {
    staticStyle: {
      "max-width": "300px"
    }
  }, [_vm._v(" These domains are used to detect a tenant's identity by domain. There should be no 'https://', no 'www' or no ending '/' at the end. Example: 'trainplanet.com' (no quotes) ")])]), _c('v-spacer'), _c('v-btn', {
    staticClass: "text-none mr-3 mb-4 mt-5 third white--text",
    on: {
      "click": _vm.addDomain
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("mdi-playlist-plus")]), _c('span', [_vm._v("Add Domain")])], 1)], 1), _vm._l(_vm.tenant.theme.domains, function (domain, domainIndex) {
    return _c('v-row', {
      key: domainIndex
    }, [_c('v-col', [_c('v-text-field', {
      staticClass: "mt-2",
      attrs: {
        "rules": [_vm.rules.required],
        "label": "Domain URL",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('v-btn', {
            staticClass: "mt-2 mr-lg-n3 mt-lg-n2",
            attrs: {
              "color": "red",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.removeDomain(domainIndex);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)];
        },
        proxy: true
      }], null, true),
      model: {
        value: _vm.tenant.theme.domains[domainIndex],
        callback: function ($$v) {
          _vm.$set(_vm.tenant.theme.domains, domainIndex, $$v);
        },
        expression: "tenant.theme.domains[domainIndex]"
      }
    })], 1)], 1);
  })], 2)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }